export const frErrorTraductions = {
  unknown: 'Une erreur est survenue, veuillez contacter le support.',
  criteria: {
    parse: 'Filtrage impossible',
  },
  event: {
    register: {
      noCreator: 'Vous êtes le créateur de cet événement',
    },
    create: {
      startBeforeToday: 'La date de début doit être dans le futur',
    },
  },
  code: {
    event: {
      alreadyExists: 'Le code doit être unique',
      invalid: 'Code invalide',
    },
  },
};
